<template>
      <v-main>
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
            >
              <v-card class="elevation-12">
                <v-toolbar
                  color="teal darken-4"
                  dark
                  flat
                >
                  <v-toolbar-title>Reset Passsword</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="yellow accent-4"
                        light
                        to='/landing'
                      >
                        <span>
                        <v-icon>mdi-home-variant</v-icon>
                        Home
                        </span>

                      </v-btn>
                    </template>
                    <span>Go Back to home page</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      label="New Password"
                      name="login"
                      :type="'password'"
                      :error-messages="passwordErrors"
                      v-model="password"
                      prepend-icon="mdi-shield-lock"
                      required
                      @input="$v.password.$touch()"
                      @blur="$v.password.$touch()"
                    ></v-text-field>
  
                    <v-text-field
                      id="password"
                      label="Confirm Password"
                      name="password"
                      v-model.lazy="confirmPassword"
                      prepend-icon="mdi-shield-lock-outline"
                      type="password"
                      required
                      :error-messages="confirmPasswordErrors"
                      @input="$v.confirmPassword.$touch()"
                      @blur="$v.confirmPassword.$touch()"
                    ></v-text-field>
                  </v-form>
                  <p class="subtitle error-msg">{{ errorMsg }}</p>
                  <div class="error-msg" v-if="failedSubmit"> 
                    Please fill up the required fields above
                  </div>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-3" dark @click="submit">
                    <span>Submit
                    <v-icon>mdi-login</v-icon>
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>  
</template>

<script>
import { EventBus } from '../utils'
import { reset_password } from '../api'
import { required } from 'vuelidate/lib/validators'
  
export default {
    name: "login",
    validations() {
      return {
        password: { required },
        confirmPassword: { required },
      }
    },
    computed: {
      passwordErrors () {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Password is required')
        return errors
      },
      confirmPasswordErrors () {
        const errors = []
        if (!this.$v.confirmPassword.$dirty) return errors
        this.confirmPassword && this.confirmPassword != this.password && errors.push('Password not matched')
        !this.$v.password.required && errors.push('Supply Password is required')
        return errors
      }

    },    
    data() {
        return {
            password: "",
            confirmPassword: "",
            failedSubmit: false,
            errorMsg: ""
        }
    },
    methods: {
        submit: function() {
          this.failedSubmit = false
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.failedSubmit = true
          } else {        

            const jwt = this.$route.params.token

            reset_password({
              password: this.password
            }, jwt).then(() => {
              this.$router.push('/login')
            })
          }
        }
    },
    mounted() {
        EventBus.$on('failedAuthentication', (msg) => {
            this.errorMsg = msg
        })
    },
    beforeDestroy() {
        EventBus.$off('failedAuthentication')
    }
}
</script>

<style scoped>
.error-msg {
  color: red;
  font-weight: bold;
}
</style>>